import React, { useState } from 'react';
import { BadgeMessage } from 'components/elements';
import { useTranslationX, useTranslation } from 'i18n';
import { Check } from 'components/icons';
import { fromSQLTimestampToBrazilian } from 'utils/calendarUtils';
import { getMasked } from 'utils/inputMask';
import styles from './AporteItem.module.scss';

interface AporteItemProps {
  aporte: any;
  onToggle: (id: string) => Promise<boolean> | boolean;
  loading?: boolean;
  isSelected?: boolean;
}

const AporteItem: React.FC<AporteItemProps> = ({
  aporte,
  onToggle,
  loading = false,
  isSelected = false,
}) => {
  const [localLoading, setLocalLoading] = useState(false);

  const handleToggle = async () => {
    setLocalLoading(true);
    try {
      const result = onToggle(
        aporte.id ?? aporte.identificacao ?? JSON.stringify(aporte)
      );
      if (result instanceof Promise) {
        await result;
      }
    } finally {
      setLocalLoading(false);
    }
  };

  const { tx } = useTranslationX('dashboard', 'finance');
  const { t } = useTranslation();

  const identificacao = aporte?.identificacao || aporte?.id || aporte?.descricao || '';

  const periodo = aporte?.periodo
    ? tx('nonCovered.period', {
        inicio: fromSQLTimestampToBrazilian(aporte.periodo.inicio?.toString?.() ?? ''),
        fim: fromSQLTimestampToBrazilian(aporte.periodo.fim?.toString?.() ?? ''),
      })
    : '';

  const bank = aporte?.banco
    ? tx('nonCovered.bank', {
        agencia: aporte.agencia || '',
        banco: aporte.banco || '',
        conta: aporte.conta || '',
      })
    : '';

  const valor =
    aporte?.valorFaltante !== undefined && aporte?.valorFaltante !== null
      ? `${t('currency')} ${getMasked(Number(aporte.valorFaltante).toFixed(2), {
          pattern: 'currency',
        })}`
      : null;
  const valueWithDate = tx('nonCovered.dataValue', {
    value: valor,
    data: fromSQLTimestampToBrazilian(aporte.dataAporte?.toString?.() ?? ''),
  });

  const textParts = [identificacao, bank, periodo, valueWithDate]
    .filter(Boolean)
    .join('<br><br>');

  const isLoading = loading || localLoading;

  return (
    <div className={styles.aporteItem}>
      <div className={styles.badgeWrapper}>
        <BadgeMessage type="error" text={textParts || JSON.stringify(aporte)} />
        <button
          className={styles.finalizarButton}
          onClick={handleToggle}
          disabled={isLoading}
        >
          <div
            className={`${styles.checkbox} ${isLoading ? styles.loading : ''} ${
              isSelected ? styles.selected : ''
            }`}
          >
            {isLoading ? (
              <div className={styles.spinner} />
            ) : isSelected ? (
              <Check size={0.6} />
            ) : null}
          </div>
          <span>{tx('nonCovered.finalizar')}</span>
        </button>
      </div>
    </div>
  );
};

export default AporteItem;
